import { format }    from 'date-fns';
import { parseISO }  from 'date-fns';
import Badge         from '../components/badge';
import React         from 'react';
import toMoneyFormat from '../util/to_money_format';


export default function InvoicesList({ businessID, invoices }) {
  const hasInvoices = invoices.length > 0;

  return (
    <React.Fragment>
      {hasInvoices && (
        <div className="invoices-list">
          <div className="invoices-list__header row no-gap">
            <div className="col-20">Date</div>
            <div className="col-40">Customer</div>
            <div className="col-20 align-right">Amount</div>
            <div className="col-20 align-center">Paid</div>
          </div>
          {invoices.map(invoice => (
            <InvoiceRow
              key={invoice.id}
              businessID={businessID}
              invoice={invoice}
            />
          ))}
        </div>
      )}
      {!hasInvoices && (<NoInvoices/>)}
    </React.Fragment>
  );
}


function InvoiceRow({ businessID, invoice }) {
  const { amount }    = invoice;
  const { totalPaid } = invoice;
  const { timestamp } = invoice;
  const { status }    = invoice;
  const { mode }      = invoice;
  const isLiveMode    = mode === 'live';
  const customerName  = invoice.customer?.name.full;
  const href          = `/${businessID}/metrics/invoices/${invoice.id}`;

  return (
    <div className="invoices-list__row row no-gap">
      <div className="col-20">
        {format(parseISO(timestamp), 'MM/d/yy')}
      </div>
      <div className="col-40 truncate display-flex align-items-center">
        {!isLiveMode && <Badge {...{ color: 'orange', text: 'Test' }}/>}<a href={href}>{customerName || '-'}</a>
      </div>
      <div className="col-20 align-right">
        {!totalPaid && toMoneyFormat({ amount })}
        {totalPaid && toMoneyFormat({ amount: totalPaid })}
      </div>
      <div className="col-20 align-center">
        <StatusIcon status={status}/>
      </div>
    </div>
  );
}


function StatusIcon({ status }) {
  if (status === 'paid')
    return <i className="icons8 icons8-green-check-mark"/>;
  else if (status === 'void')
    return <i className="f7-icons void-icon">close</i>;
  else if (status === 'refunded')
    return <i className="f7-icons refunded-icon">reload</i>;
  else
    return null;
}


function NoInvoices() {
  return (
    <div className="block">
      <div className="empty-page">
        <div className="empty-page__note">
          No invoices to show
        </div>
        <div className="empty-page__icons">
          <i className="empty-page__icon icons8 icons8-electrical"></i>
        </div>
      </div>
    </div>
  );
}
